import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PostContainer from '../../Components/PostContainer/PostContainer';
import SideBar from '../../Components/SideBar/SideBar';
import { fetchPosts } from '../../features/posts/postsAPI';
import { getPosts } from '../../features/posts/postSlice';

const Home = () => {
    const { posts, loading, isError, errorMessage } = useSelector(state => state.posts)
    const filter = useSelector(state => state.filter)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getPosts(filter))
    }, [dispatch, filter])

    let content = <></>
    if (loading) {
        content = <div className='text-center'>
            Loading...

        </div>
    }
    else if (!loading && isError) {
        content = <div className='text-center'>
            something went wrong. {errorMessage.message}

        </div>
    }
    else if (!loading && !isError && !posts.length) {
        content = <div className='text-center'>
            Data not found!
        </div>

    }
    else if (!loading && posts.length) {
        content = <PostContainer allBlog={posts}>
        </PostContainer>

    }
    return (
        <section className="wrapper">
            <SideBar></SideBar>
            {content}
        </section>
    );
};

export default Home;